import classNames from 'classnames/bind';
import styles from './FormTextArea.module.scss';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';

let cx = classNames.bind(styles);

function errorText(error, name, label) {
	if (error[name].type === 'required') {
		return !error[name].message ? 'Required' : error[name].message;
	} else {
		return !error[name].message ? `Invalid ${label}` : error[name].message;
	}
}

export function FormTextArea({ label, id, required, className, minLength, maxLength, name, value, ...props }) {
	const classNameArray = className?.split(' ') || [];
	const [isFocused, setIsFocused] = useState(false);
	const handleFocus = () => setIsFocused(true);
	const handleBlur = () => setIsFocused(false);

	let registerInput = function (string, registerOptions) {
		return;
	};
	let formStateObj;
	if (useFormContext()) {
		const { register, formState } = useFormContext();
		formStateObj = formState;
		registerInput = register;
	}

	const registerOptions = {
		required: required,
		maxLength: maxLength,
		minLength: minLength,
		onBlur: handleBlur,
	};

	return (
		<div className={cx(['ns_text-area-container', 'text-area-container', isFocused && 'in-focus', formStateObj?.errors?.[name] && 'error', formStateObj?.dirtyFields?.[name] && 'dirty', ...classNameArray])}>
			{label && <label className={cx(['ns_label', 'label'])} htmlFor={id} dangerouslySetInnerHTML={{ __html: label + (required?.value ? '*' : '') }} />}
			<textarea className={cx(['ns_text-area', 'text-area'])} id={id} {...registerInput(name, registerOptions)} aria-describedby={`${id}-help`} onFocus={handleFocus} defaultValue={value}{...props} />
			{formStateObj?.errors?.[name] && (
				<small role="alert" id={`${id}-help`} className={cx(['text-area-error'])}>
					{errorText(formStateObj?.errors, name, label)}
				</small>
			)}
		</div>
	);
}
